/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class AdvancedFunApi {
    static getInstance() {
        if (!this.instance) this.instance = new AdvancedFunApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 车辆信息
    async getVehicleList (param, page_num, page_size){
        let url = `/api/sys/v2/vehicle/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 车辆数据-获取部件具体信息
    async getPartsVersion (id){
        let url = `/api/sys/vehicle/version/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 编辑扭矩
    async editTorque(param){
        let url = `/api/sys/torque`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消扭矩升级
    async cancelTorqueUpgrade(vehicle_id){
        let url = `/api/sys/torque/${vehicle_id}/vehicle/cancel`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 取消电机更换
    async cancelMotorReplace(vehicle_id){
        let url = `/api/sys/triple/${vehicle_id}/vehicle/cancel`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 获取扭矩列表
    async getTorqueList(param){
        let url = `/api/sys/torque/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 车辆与用户解绑
    async unbindBikeUser(id){
        let url = `/api/sys/v2/vehicle/unbind/${id}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 申请更换电机
    async applyReplaceMotor(param){
        let url = `/api/sys/triple`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 电机更换申请记录
    async applyRecord(param,page_num,page_size){
        let url = `/api/sys/triple/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 取消电机更换申请
    async cancleApply(vehicle_id){
        let url = `/api/sys/triple/${vehicle_id}/vehicle/cancel`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 获取配置信息
    async getConfigInfo(frame_number){
        let url = `/api/sys/config/${frame_number}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 更新配置信息
    async updateConfigInfo(param, frame_number){
        let url = `/api/sys/config/update/${frame_number}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 版本记录列表
    async configVersionList(param, page_num, page_size){
        let url = `/api/sys/vehicle/config/record/listPage?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 版本回滚
    async versionRollBack(param){
        let url = `/api/sys/vehicle/config/record/rollback`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取绑定记录
    async getBindRecordList(param, page_num, page_size){
        let url = `/api/sys/vehicle/bind/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 删除部件
    async deletePart(id, part_id){
        let url = `/api/sys/parts/${id}/remove?part_id=${part_id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取当前设置
    async getCurrentSetting(param){
        let url = `/api/sys/vehicle/setting/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取上电信息列表
    async getSeriesList(param,page_num,page_size){
        let url = `/api/sys/ride/series/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 脱敏数据
    async desensitizedData(param, id){
        let url = `/api/v1/common/restore/${id}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存轮径和最大速度
    async saveWheelCircumferenceAndMaxSpeed(param, frame_number){
        let url = `/api/sys/config/update/value/${frame_number}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取summery数据
    async getSummeryData(param, page_num, page_size){
        let url = `/api/sys/ride/summery/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 生成绑车条码
    async getBarCode(param){
        let url = `/api/sys/vehicle/vali/code`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 生成电机二维码
    async getQRCode(param){
        let url = `/api/sys/vehicle/triple/code`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 编辑车辆类型
    async saveCategory(id,category){
        let url = `/api/sys/vehicle/category/${id}?category=${category}`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 获取电机秘钥
    async getMotorKey(id){
        let url = `/api/sys/v2/vehicle/key/${id}`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取设置记录
    async getSettingRecordList(param, page_num, page_size){
        let url = `/api/sys/vehicle/setting/record/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }
    
    // 获取维修记录
    async getRepairRecordList(param, page_num, page_size){
        let url = `/api/sys/vehicle/repair/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取鉴权记录
    async getAuthRecordList(param, page_num, page_size){
        let url = `/api/sys/auth/record/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取上电位置
    async getPoweronPositionList(param, page_num, page_size){
        let url = `/api/sys/position/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取全部租户
    async getAllTenant(){
        let url = `/api/sys/tenant/dropdown/query`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 获取全部租户
    async getAllTenant2(param){
        let url = `/api/sys/tenant/dropdown/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

     // 获取日志信息列表
     async getLogInfo (param,page_num,page_size){
        let url = `/api/sys/upgrade/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取升级错误信息列表
    async getErrorLog (id,param){
        let url = `/api/sys/upgrade/error/${id}`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取故障日志列表
    async getFaultLog (param,id){
        // let url = `/api/sys/fault/list?page_num=${page_num}&page_size=${page_size}`
        let url =`/api/sys/fault/item/data/${id}?page_num=${param.page_num}&page_size=${param.page_size}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // Bluetooth 日志列表（仅四个参数）
    async getBluetoothLog(param, page_num, page_size){
        let url = `/api/sys/ble/connect/record/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url, param, 'POST')
        return result
    }

    // Bluetooth 日志文件下载
    async downloadBluetoothFile(file_no){
        let url = `/api/ble/conn/download/${file_no}`
        let result = await this.getData(url, {}, 'GET')
        return result
    }

    // 恢复下线
    async restoreOffline(id){
        let url = `/api/sys/vehicle/restore/offline/${id}`
        let result = await this.getData(url,{},'POST')
        return result
    }

    // 清空部件
    async deleteAllPart(id){
        let url = `/api/sys/parts/${id}/remove`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 下载电机原始数据
    async downloadMotor(param){
        let url = `/api/sys/ride/mcu/point/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载电池原始数据
    async downloadBattery(param){
        let url = `/api/sys/ride/bms/point/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载仪表原始数据
    async downloadDisplay(param){
        let url = `/api/sys/ride/display/point/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 下载故障原始数据
    async downloadFault(param){
        let url = `/api/sys/fault/item/download`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取SKU几何参数列表
    async getErgoAdjustList(param, page_num, page_size){
        let url = `/api/sys/vehicle/geometry/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 保存人体工学调节参数
    async saveErgoAdjustParams(param, sku, type){
        let url = `/api/sys/vehicle/geometry/${sku}?type=${type}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 车辆绑定SKU几何参数
    async bindSKU(param, id){
        let url = `/api/sys/vehicle/sku/${id}?sku=${param.sku}`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 修改MVP，车型是否支持人体工学
    async editMVP(param, id){
        let url = `/api/sys/vehicle/mvp/${id}?mvp=${param.mvp}`
        let result = await this.getData(url,{},'PUT')
        return result
    }

    // 删除SKU几何参数
    async deleteSKUErgoAdjust(id){
        let url = `/api/sys/vehicle/geometry/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取SKU列表
    async getSKUList(param){
        let url = `/api/sys/vehicle/geometry/sku/dropdown`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取车型列表
    async getEditRecordList(sku){
        let url = `/api/sys/vehicle/geometry/record/${sku}`
        let result = await this.getData(url,{},'get')
        return result
    }

    // 取消轮径和最大速度 参数配置修改
    // async cancelWheelCircumferenceAndMaxSpeed(param, frame_number){
    //     let url = `/api/sys/config/cancel/value/${frame_number}`
    //     let result = await this.getData(url,param,'POST')
    //     return result
    // }
}

export {
    AdvancedFunApi
}